import { Capacitor, registerPlugin } from '@capacitor/core';

const noopResult = { ok: false, error: 'Android table server plugin not available' };

const AndroidTableServerPlugin = registerPlugin('AndroidTableServer');

const isAndroidNative = () => {
  try {
    return Capacitor?.isNativePlatform?.() === true && Capacitor?.getPlatform?.() === 'android';
  } catch (_) {
    return false;
  }
};

async function safeInvoke(method, payload = {}) {
  if (!isAndroidNative() || !AndroidTableServerPlugin || typeof AndroidTableServerPlugin[method] !== 'function') {
    return { ...noopResult };
  }
  try {
    const result = await AndroidTableServerPlugin[method](payload);
    if (result && typeof result === 'object') return result;
    return { ok: true, data: result };
  } catch (error) {
    return { ok: false, error: error?.message || String(error || 'Unknown plugin error') };
  }
}

export default {
  isAvailable: isAndroidNative,
  startServer: (payload = {}) => safeInvoke('startServer', payload),
  stopServer: () => safeInvoke('stopServer'),
  getStatus: () => safeInvoke('getStatus'),
  getLocalIp: () => safeInvoke('getLocalIp')
};

